module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./WorkAuthView.js"));
	}, "WorkAuthView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=WorkAuthView!./src/pages/Shop/WechatAuth/WorkAuth/WorkAuthView.js
// module id = 884
// module chunks = 438